module.exports = __webpack_public_path__ + "static/media/404-xingqiu.2a23d9ee.png";